import React from 'react';
import Hero from '../components/Hero';

const Home = () => {
  const scrollToCards = () => {
    console.log('Scroll function called');
    const cardsSection = document.getElementById('sports-cards');
    console.log('Cards section found:', cardsSection);
    if (cardsSection) {
      cardsSection.scrollIntoView({ behavior: 'smooth' });
      console.log('Scrolling to cards section');
    } else {
      console.log('Cards section not found');
    }
  };

  return (
    <div className="font-sans bg-ink text-white">
      <Hero onWatchClick={scrollToCards} />
      

      {/* Sports Showcase */}
      <section id="sports-cards" className="section-padding">
        <div className="container-custom">
          <div className="text-center mb-16">
            <h2 className="text-4xl font-display font-bold text-white mb-4">
              Premium Sports Content
            </h2>
            <p className="text-xl text-gray-300 max-w-3xl mx-auto font-display">
              Enjoy exclusive access to America's most popular sports leagues with 
              comprehensive coverage and expert commentary.
            </p>
          </div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
            {/* NFL Service */}
            <div className="card-glass card-hover overflow-hidden">
              <div className="h-64 bg-cover bg-center flex items-center justify-center relative" style={{ backgroundImage: "url('/assets/nfl_card_header.png')" }}>
                <div className="absolute inset-0 bg-black bg-opacity-80"></div>
                <div className="text-center text-white font-display relative z-10">
                  <div className="text-8xl mb-4">🏈</div>
                  <h2 className="text-3xl font-bold font-display">NFL Streaming</h2>
                  <p className="text-white/80 mt-2 font-sans">National Football League</p>
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-white mb-4 font-display">
                  Complete NFL Coverage
                </h3>
                <p className="text-gray-300 mb-6 font-sans">
                  Watch every NFL game with our comprehensive coverage including regular season, 
                  playoffs, and Super Bowl with multiple camera angles and expert commentary.
                </p>
                
                <div className="space-y-4 mb-8">
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">All 32 teams coverage</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">Thursday Night Football</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">Monday Night Football</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">Super Bowl exclusive access</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">RedZone channel</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">Game replays & highlights</span>
                  </div>
                </div>

                <button className="btn-pill-primary w-full font-display">
                  Download NFL Bite
                </button>
              </div>
            </div>

            {/* NBA Service */}
            <div className="card-glass card-hover overflow-hidden">
              <div className="h-64 bg-cover bg-center flex items-center justify-center relative" style={{ backgroundImage: "url('/assets/nba_card_header.png')" }}>
                <div className="absolute inset-0 bg-black bg-opacity-80"></div>
                <div className="text-center text-white font-display relative z-10">
                  <div className="text-8xl mb-4">🏀</div>
                  <h2 className="text-3xl font-bold font-display">NBA Streaming</h2>
                  <p className="text-white/80 mt-2 font-sans">National Basketball Association</p>
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-white mb-4 font-display">
                  Full NBA Experience
                </h3>
                <p className="text-gray-300 mb-6 font-sans">
                  Enjoy complete NBA coverage from regular season through playoffs and Finals 
                  with courtside cameras, player stats, and expert analysis.
                </p>
                
                <div className="space-y-4 mb-8">
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">All 30 teams access</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">NBA Finals exclusive</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">All-Star Weekend coverage</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">Player interviews</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">Real-time statistics</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">Classic games archive</span>
                  </div>
                </div>

                <button className="btn-pill-primary w-full font-display">
                  Download NBA Bite
                </button>
              </div>
            </div>

            {/* NHL Service */}
            <div className="card-glass card-hover overflow-hidden">
              <div className="h-64 bg-cover bg-center flex items-center justify-center relative" style={{ backgroundImage: "url('/assets/nhl_card_header.png')" }}>
                <div className="absolute inset-0 bg-black bg-opacity-80"></div>
                <div className="text-center text-white font-display relative z-10">
                  <div className="text-8xl mb-4">🏒</div>
                  <h2 className="text-3xl font-bold font-display">NHL Streaming</h2>
                  <p className="text-white/80 mt-2 font-sans">National Hockey League</p>
                </div>
              </div>
              <div className="p-8">
                <h3 className="text-2xl font-bold text-white mb-4 font-display">
                  Complete NHL Coverage
                </h3>
                <p className="text-gray-300 mb-6 font-sans">
                  Watch all NHL action including regular season, playoffs, and Stanley Cup Finals 
                  with ice-level cameras and comprehensive game analysis.
                </p>
                
                <div className="space-y-4 mb-8">
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">All 32 teams coverage</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">Stanley Cup Playoffs</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">Winter Classic special events</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">Behind-the-scenes content</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">Multi-angle replays</span>
                  </div>
                  <div className="flex items-center">
                    <svg className="w-5 h-5 text-primary mr-3" fill="currentColor" viewBox="0 0 20 20">
                      <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                    </svg>
                    <span className="text-gray-300">Historical game archives</span>
                  </div>
                </div>

                <button className="btn-pill-primary w-full font-display">
                  Download NHL Bite
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="section-padding panel-surface text-white font-display">
        <div className="container-custom text-center">
          <h2 className="text-4xl font-display font-bold mb-6">
            Ready to Experience Premium Sports Streaming?
          </h2>
          <p className="text-l mb-8 max-w-2xl mx-auto">
            Join millions of sports fans who trust IBT Sports for their live streaming needs. 
            Start watching today with our licensed, high-quality platform.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <img src="/assets/download_badge.svg" alt="App Store" className="h-20 drop-shadow-[0_0_24px_rgba(225,23,23,0.35)]"/>
          </div>
        </div>
      </section>

    </div>
  );
};

export default Home; 